import Retreats from '../components/Retreats';

const RetreatsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-900 via-primary-900 to-neutral-900 pt-20">
      <Retreats />
    </div>
  );
};

export default RetreatsPage;
